module.exports = __webpack_public_path__ + "static/ofcar6-817d4d40d79ab26fe6d119936ec2b9a4.jpg";